import { DefaultTransactionColumnHeader } from "./DefaultTransactionColumnHeader";
import { TransactionColumn } from "./TransactionColumn";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { TransactionColumnFilterAccount } from "./TransactionColumnFilterAccount";

export function TransactionColumnHeaderAccount(): JSX.Element {
  return (
    <TransactionColumnSizer column={TransactionColumn.ACCOUNT}>
      <DefaultTransactionColumnHeader
        column={TransactionColumn.ACCOUNT}
        text={"Account"}
        FilterType={TransactionColumnFilterAccount}
      />
    </TransactionColumnSizer>
  );
}
